import React from 'react';
import RangePicker from '@home/components/RangePicker';
import type { Moment } from 'moment';
import './index.scss';

const DEFAULT_LABEL_EN = 'Batch select display date range';
const DEFAULT_LABEL_CN = '批量选择展示日期范围';

export interface IParentDateFilterProps {
  isEn: boolean;
  labelEn?: string;
  labelCn?: string;
  value: [Moment, Moment];
  onChange?: (value: [Moment, Moment]) => void;
}

const ParentDateFilter: React.FC<IParentDateFilterProps> = ({
  isEn,
  labelEn,
  labelCn,
  value,
  onChange,
}) => {
  const batchLabel = isEn
    ? labelEn || DEFAULT_LABEL_EN
    : labelCn || DEFAULT_LABEL_CN;

  return (
    <div className="dbh-parent-date-filter">
      <span className="dbh-parent-date-filter__label">{batchLabel}</span>
      <div className="search-item search-item-date">
        <RangePicker
          value={value}
          onChange={onChange}
          type="date"
          typeList={['date']}
          showSelectType={false}
          showShortcut={false}
          language={isEn ? 'en' : 'cn'}
          syncInput={true}
        />
      </div>
    </div>
  );
};

export default ParentDateFilter;
